import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

export default function NubankQRCode() {
  const pixCode = '00020126580014BR.GOV.BCB.PIX0136e94461fc-b0b9-4329-bf32-fe0c2a804fb65204000053039865802BR5925Joao Pedro da Silva Krige6009SAO PAULO621405107qjwtj4w2H6304617E';
  const pixLink = 'https://nubank.com.br/cobrar/ym0ad/697c9782-66bd-430a-8037-21c9077dc6ce';
  return (
    <div style={{ textAlign: 'center', marginTop: 24 }}>
      <h2>Me apoie via Pix!</h2>
      <QRCodeSVG value={pixCode} size={200} />
      <p style={{ wordBreak: 'break-all', marginTop: 12 }}><b>Copia e cola Pix:</b><br />{pixCode}</p>
      <a href={pixLink} target="_blank" rel="noopener noreferrer">Ou pague pelo link do Nubank</a>
    </div>
  );
}
